import { type RouteLocationNormalizedLoaded } from 'vue-router';
import { KAKAO_PIXEL } from '@/constants/marketing';
import { getRawQueryParam } from '~/utils/common';

// url 이동
export const goTo = (url: string): void => {
  const router = useRouter();
  const route = useRoute();
  
  if (!url) url = '/';
  
  if (url.startsWith('http')) {
    url = getAbsPath(url);
  }
  
  if (url === route.fullPath) {
    router.go(0);
  } else {
    navigateTo(url);
  }
};

// router replace 처리
export const replaceUrl = (url: string): void => {
  const router = useRouter();
  
  if (!url) url = '/';
  
  if (url.startsWith('http')) url = getAbsPath(url);
  router.replace(url);
};

// 모든 query params를 변환하는 함수
export const getAllEncodedQueryParams = () => {
  const route = useRoute();
  const params = route.query;

  //query 돌면서 찾기 각각 적용시킴
  const transformedParams = Object.keys(params).reduce((acc: any, key : any) => {
    acc[key] = getRawQueryParam(key); 
    return acc;
  }, {});

  console.table(transformedParams);
  return transformedParams;
};


// 마케팅 url처리 ::::::
export const encodeAirbridgeReferrer = () => {
  const airbridgeReferrer = getRawQueryParam('airbridge_referrer');
  const naPm = getRawQueryParam('NaPm');


  if (airbridgeReferrer || naPm) {
    const transformedParams = getAllEncodedQueryParams();
    const newUrl = new URL(window.location.href);

    // searchParams.set을 사용하면 자동 인코딩이 발생 
    // decodeURIComponent()를 적용하여 이중 인코딩 방지
    Object.keys(transformedParams).forEach((key) => {
      newUrl.searchParams.set(key, decodeURIComponent(transformedParams[key]));
    });

    //리로드 없이 url업데이트
    window.history.replaceState({}, '', newUrl.toString());
  }
};

// 페이지 스크립트 로딩
export const pageInit = (to: (RouteLocationNormalizedLoaded | null) = null): void => {
  const route = useRoute();

  /**** 기존 HeaderModule에 포함되었던 스크립트 (start) ****/  
  const urlPath = to ? to.path : route.path;
  
  // 네이버 웹마스터 도구(연관채널)
  if (urlPath === '/') naverAssociatedChannel();

  googleGTMSend(to);

  if (!KAKAO_PIXEL.page.includes(urlPath)) kakaoPixel('');

  facebookPixelForUser();
  airbridgeSendEvent('airbridge.ecommerce.home.viewed');
  
  //네이버 전환 스크립트
  naverPageInflow('', '');

  //traceLog이벤트 추가
  makeBrowserCookie();
  callTraceLogEvent(); 

  //에어브릿지 인코딩 
  encodeAirbridgeReferrer();
};

